const createAnalyticsId = (id: string) => {
    return `hs.${id}`;
};

export const ANALYTICS_IDS = {
    serviceSave: createAnalyticsId("service.save"),
    serviceUnsave: createAnalyticsId("service.unsave"),
    serviceMoreInfo: createAnalyticsId("service.more-info"),
    serviceWebsite: createAnalyticsId("service.website"),
    servicePhoneNumber: createAnalyticsId("service.phone-number"),
    serviceLocationEmail: createAnalyticsId("service.location.email"),
    serviceLocationMap: createAnalyticsId("service.location.map"),
    getStartedCta: createAnalyticsId("get-started"),
    selectSuburbCta: createAnalyticsId("select-suburb"),
    regionSet: createAnalyticsId("region-set"),
};
